export enum INPUT_TYPE {
  SELECT = 'select',
  INPUT = 'input',
  RADIO = 'radio',
  FILE = 'file',
}
export enum TextType {
  FORMCONTROL_LABEL = 'formControlLabel',
  FORM_CONTROL_ERROR = 'formControlError',
  SELECT_PLACEHOLDER = 'selectPlaceholder',
}
export enum VALIDATION_ERRORS_ENUM {
  ANSWER_REQUIRED = 'answerRequired',
  ANSWER_LIMIT_EXCEEDED = 'answerLimitExceeded',
}
export const VALIDATION_ERRORS = {
  [VALIDATION_ERRORS_ENUM.ANSWER_REQUIRED]: 'Answer is required',
  [VALIDATION_ERRORS_ENUM.ANSWER_LIMIT_EXCEEDED]: 'Maximum number of selections exceeded'
};

// Operator map for condition matching (ported from old library)
export const operatorMap = ({
  not_equals: 'not_equals',
  equals: 'equals',
  includes: 'includes',
  not_includes: 'not_includes',
  metadata_equals: 'metadata_equals',
  metadata_not_equals: 'metadata_not_equals',
  metadata_includes: 'metadata_includes',
  metadata_not_includes: 'metadata_not_includes'
} as const);

// Delimiter used for metadata condition values (e.g., "category==A")
export const CONDITION_DELIMITER = '==';